export default __webpack_public_path__ + "static/media/Tv-qsm06do1eaeokuw9gf8fuwwzxp6uxycowjd4gudt2o.1e95d59e.png";